import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ClipboardCheckIcon, FactoryIcon, PackageIcon, FileTextIcon, ShoppingCartIcon, SettingsIcon, CogIcon, ShoppingBagIcon, ArrowRightIcon, FlaskConicalIcon, CpuIcon, BuildingIcon, SmartphoneIcon } from 'lucide-react';
function MenuItem({
  icon: Icon,
  label,
  to
}: {
  icon: ComponentType<{
    className?: string;
  }>;
  label: string;
  to: string;
}) {
  return <Link to={to} className="flex items-center gap-3 group/item" data-id="element-480" data-mp="1lr28d1x694eq">
      <div className="p-1.5 rounded-md bg-white/5 group-hover/item:bg-violet-electric/20 transition-colors" data-id="element-481" data-mp="1qj2e5azxarj8">
        <Icon className="w-4 h-4 text-white/60 group-hover/item:text-violet-electric transition-colors" data-id="element-482" data-mp="1bufp2hkhulet" />
      </div>
      <span className="text-white/80 text-sm font-medium group-hover/item:text-white transition-colors" data-id="element-483" data-mp="1gtiuw48asvnu">
        {label}
      </span>
    </Link>;
}
export function SolutionsMenu({
  onClose
}: {
  onClose?: () => void;
}) {
  return <div className="absolute top-full left-1/2 -translate-x-1/2 w-[1100px] pt-3 z-50" onClick={onClose} data-id="element-484" data-mp="17u5gqy98biws">
      
      <div className="bg-[#0D0B2E]/95 backdrop-blur-xl border border-white/10 rounded-xl shadow-2xl overflow-hidden" data-id="element-485" data-mp="18dxzqr8haox3">
        <div className="grid grid-cols-12 divide-x divide-white/10" data-id="element-486" data-mp="1ia0yro81a7ft">
          {/* Left Column: Intro */}
          <div className="col-span-3 p-6 bg-white/[0.02] flex flex-col justify-between" data-id="element-487" data-mp="1daoffdgdfihz">
            <div data-id="element-488" data-mp="plc4o95eb2dk">
              <h3 className="text-white font-semibold text-sm tracking-wide mb-3" data-id="element-489" data-mp="pku450bpa1zu">
                All Solutions
              </h3>
              <p className="text-white/60 text-sm leading-relaxed" data-id="element-490" data-mp="ko3k61wrym95">
                Operational modules built to work together. Adaptable to your
                company's workflows.
              </p>
            </div>
          </div>

          {/* By Module */}
          <div className="col-span-3 p-6" data-id="element-491" data-mp="6ucckz2ltcg2">
            <h3 className="text-white/40 text-[10px] font-bold uppercase tracking-widest mb-4" data-id="element-492" data-mp="6t9ot00kvq4d">
              By Module
            </h3>
            <div className="grid grid-cols-1 gap-y-3" data-id="element-493" data-mp="21yiog0jms3qe">
              <MenuItem icon={ShoppingCartIcon} label="Purchasing" to="/solutions/purchasing" data-id="element-494" data-mp="21y0lym6dkta1" />
              
              <MenuItem icon={PackageIcon} label="Inventory Management" to="/solutions/inventory-management" data-id="element-495" data-mp="26v93qlnm2var" />
              
              <MenuItem icon={FactoryIcon} label="Production" to="/solutions/manufacturing-mes" data-id="element-496" data-mp="2fpfhfshgymxz" />
              
              <MenuItem icon={ClipboardCheckIcon} label="Quality" to="/solutions/quality" data-id="element-497" data-mp="1izy18jkv1ii1" />
              
              <MenuItem icon={FileTextIcon} label="Sales and Quoting" to="/solutions/sales-and-quoting" data-id="element-498" data-mp="1nxpubgx8rant" />
              
            </div>
          </div>

          {/* By Industry */}
          <div className="col-span-3 p-6 bg-white/[0.02]" data-id="element-499" data-mp="1wyxnxlotbnbk">
            <h3 className="text-white/40 text-[10px] font-bold uppercase tracking-widest mb-4" data-id="element-500" data-mp="1x0h5dfm7g4ex">
              By Industry
            </h3>
            <div className="grid grid-cols-1 gap-y-3" data-id="element-501" data-mp="38e2ytcz3ks69">
              <MenuItem icon={FactoryIcon} label="Manufacturing" to="/industries/manufacturing" data-id="element-502" data-mp="38ci2pix4x16a" />
              
              <MenuItem icon={CogIcon} label="Industrial Operations" to="/industries/industrial-operations" data-id="element-503" data-mp="3ik44xjruz624" />
              
              <MenuItem icon={ShoppingBagIcon} label="Complex Consumer Products" to="/industries/consumer-products" data-id="element-504" data-mp="38s86u8prvfxw" />
              
              <MenuItem icon={FlaskConicalIcon} label="Biotech" to="/industries/biotech" data-id="element-505" data-mp="34q3ereez2rdd" />
              
            </div>
          </div>

          {/* By Plan */}
          <div className="col-span-3 p-6" data-id="element-506" data-mp="2usyp34lx4drt">
            <h3 className="text-white/40 text-[10px] font-bold uppercase tracking-widest mb-4" data-id="element-507" data-mp="2ur43rp6qijn7">
              By Plan
            </h3>
            <div className="grid grid-cols-1 gap-y-3" data-id="element-508" data-mp="2pvfau4p800zv">
              <MenuItem icon={CpuIcon} label="Thruline Core" to="/solutions/custom" data-id="element-509" data-mp="2ltbxtbmwkoch" />
              
              <MenuItem icon={BuildingIcon} label="Thruline Enterprise" to="/solutions/enterprise" data-id="element-510" data-mp="o0xzscq88nai" />
              
              <MenuItem icon={SmartphoneIcon} label="ReceivePro" to="/solutions/receivepro" data-id="element-511" data-mp="k1fbr833zw3g" />
              
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="grid grid-cols-12 divide-x divide-white/10 border-t border-white/10 bg-white/[0.02]" data-id="element-512" data-mp="w1m4ijy5i18q">
          <div className="col-span-3" data-id="element-513" data-mp="i2mgneigpqdm"></div>
          <Link to="/solutions" className="col-span-3 px-6 py-3 flex items-center justify-between group hover:bg-white/[0.04] transition-colors" data-id="element-514" data-mp="m4hcw4ljddkj">
            
            <span className="text-white/90 text-xs font-medium" data-id="element-515" data-mp="8c1jlvifstwt">
              View all modules
            </span>
            <ArrowRightIcon className="w-3.5 h-3.5 text-white/40 group-hover:text-white group-hover:translate-x-0.5 transition-all" data-id="element-516" data-mp="d5vymln3kkpk" />
          </Link>
          <Link to="/solutions#industries" className="col-span-3 px-6 py-3 flex items-center justify-between group hover:bg-white/[0.04] transition-colors" data-id="element-517" data-mp="3fb2r5yt5uac">
            
            <span className="text-white/90 text-xs font-medium" data-id="element-518" data-mp="3qipn5gxu990d">
              View all industries
            </span>
            <ArrowRightIcon className="w-3.5 h-3.5 text-white/40 group-hover:text-white group-hover:translate-x-0.5 transition-all" data-id="element-519" data-mp="36wdziam7zv6e" />
          </Link>
          <div className="col-span-3" data-id="element-520" data-mp="320743brga22p"></div>
        </div>
      </div>
    </div>;
}